import { Table } from "antd";
import styled from "styled-components";

import color from "../_style/color";

export default styled(Table).attrs((props) => ({
  pagination: props.pagination || false,
  bordered: props.bordered,
}))`
  .ant-table-thead > tr > th {
    padding: 15px 10px;
    background: ${color.light};
    border-color: ${color.gainsboro} !important;
    border-right: 1px solid ${color.gainsboro};
  }

  .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  .ant-table-tbody > tr > td {
    border: 0;
    padding: 6px 10px;
    border-right: 1px solid ${color.gainsboro};
  }

  .ant-table-tbody > tr:hover > td {
    background: ${color.aliceBlue};
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 0;
  }

  .ant-empty {
    height: 100px;
    margin: 0;
  }

  .ant-empty-image,
  .ant-empty-description {
    display: none;
  }

  .ant-table-tbody > tr > td,
  .ant-table.ant-table-bordered tbody > tr > td {
    border-color: ${color.gainsboro};
    border-bottom: ${({ bordered }) => bordered && `1px solid ${color.gainsboro}`};
  }

  .ant-table-cell-fix-left-last::after {
    content: unset;
  }
`;
